module.exports = __webpack_public_path__ + "static/4d3d594b7cacc0ed6966e269cf347a1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/live-collaboration.jpg
// module id = 1193
// module chunks = 0